<template>
    <list-view class="service-map-store-list-view">
        <template slot="filterContent">
            <veui-button @click="columnDialogOpen = true">选择数据</veui-button>
            <veui-button @click="openSortDialog">排序设置</veui-button>
            <veui-button :disabled="!batchDeleteEnable" @click="batchDelete">批量删除</veui-button>
            <veui-fieldset>
                <veui-field>
                    <veui-select :options="store.provinceDatasource"
                        placeholder="省"
                        @change="store.filter.city = null"
                        v-model="store.filter.province"/>
                </veui-field>
                <veui-field>
                    <veui-select :options="cityDatasource"
                        placeholder="市"
                        v-model="store.filter.city"/>
                </veui-field>
                <veui-field field="title" name="title">
                    <veui-searchbox v-model="store.filter.title"
                        placeholder="门店名称"
                        v-autosubmit.search/>
                </veui-field>
            </veui-fieldset>
            <veui-field :disabled="store.sync" v-if="!!store.tableInfo" tip="是否同步到地图">
                <veui-checkbox v-model="store.sync" @change="sync"/>
            </veui-field>
        </template>
        <template slot="tableColumns">
            <template v-for="column in store.allColumnDatasource">
                <veui-table-column v-if="column.value !== 'operations'"
                    :key="column.value"
                    :field="column.value"
                    :title="column.label"/>
            </template>
            <veui-table-column field="operations" title="操作">
                <template slot-scope="props">
                    <veui-button ui="link" @click="deleteConfirm(props.item)">删除</veui-button>
                </template>
            </veui-table-column>
        </template>

        <veui-dialog overlay-class="column-overlay"
            :open.sync="columnDialogOpen"
            title="选择列">
            <veui-checkbox-group :items="store.allColumnDatasource" v-model="tmpColumns" @change="countCheck"/>
            <veui-span>提示：最多可选择6个字段</veui-span>
            <template slot="foot">
                <veui-button ui="primary" @click="selectColumn">确认</veui-button>
                <veui-button @click="columnDialogOpen = false">取消</veui-button>
                <veui-button @click="tmpColumns = []">重置</veui-button>
            </template>
        </veui-dialog>

        <veui-dialog overlay-class="sort-overlay"
            title="设置排序条件"
            :open.sync="sortDialogOpen">
            <sort :fields="store.customFields" ref="sort" v-model="tmpSort" :max-count="15"/>
            <template slot="foot">
                <veui-button ui="primary" @click="sortOk">确定</veui-button>
                <veui-button @click="sortDialogOpen = false">取消</veui-button>
            </template>
            </veui-dialog>
    </list-view>
</template>

<script>
import ListView from '@baidu/ve-ria/views/ListView';
import ListModel from './ListModel';
import createView from '@baidu/ve-ria/views/createView';
import Sort from './Sort';
import {
    Field,
    Fieldset,
    Span,
    Button,
    Select,
    Column,
    Checkbox,
    Searchbox,
    Dialog,
    CheckboxGroup
} from 'veui';
import {find, map, get} from 'lodash';
import autoSubmit from '@baidu/ve-ria/directives/autoSubmit';

export default createView(ListView, ListModel, {
    name: 'MapStoreListView',
    components: {
        'veui-fieldset': Fieldset,
        'veui-field': Field,
        'veui-table-column': Column,
        'veui-select': Select,
        'veui-searchbox': Searchbox,
        'veui-checkbox': Checkbox,
        'veui-button': Button,
        'veui-dialog': Dialog,
        'veui-checkbox-group': CheckboxGroup,
        'veui-span': Span,
        Sort
    },
    created() {
        this.store.requestTableInfo();
    },
    data() {
        return {
            columnDialogOpen: false,
            sortDialogOpen: false,
            tmpColumns: this.store.tableColumns.slice(0),
            tmpSort: this.store.filter.sortBy || ':1'
        };
    },
    directives: {
        autosubmit: autoSubmit
    },
    computed: {
        cityDatasource() {
            let province = this.store.filter.province;
            let city = get(find(this.store.region, {name: province}), 'children');
            return [{label: '市', value: ''}].concat(
                map(city, i => ({label: i.name, value: i.name})));
        },
        batchDeleteEnable() {
            return !!get(this.store.tableSelected, 'length');
        }
    },
    methods: {
        async deleteConfirm({id}) {
            let result = await this.waitConfirm('请确认是否删除本条门店信息?', '温馨提示');
            if (result) {
                this.store.requestDeleteStore(id);
                this.showToast('删除成功', {type: 'success'});
                this.store.requestList();
            }
        },
        async sync() {
            await this.store.requestSync();
            this.store.requestList();
        },
        selectColumn() {
            this.columnDialogOpen = false;
            this.store.tableColumns = this.tmpColumns.slice(0);
        },
        openSortDialog() {
            this.tmpSort = this.store.filter.sortBy || ':1';
            this.sortDialogOpen = true;
        },
        countCheck() {
            if (this.tmpColumns.length > 6) {
                this.$nextTick(() => {
                    this.tmpColumns = this.tmpColumns.slice(0, 6);
                });
            }
        },
        async sortOk() {
            let result = await this.$refs.sort.validate();
            if (result === -1) {
                this.waitAlert('不能选择重复的排序字段！', '错误');
            }
            if (result === true) {
                this.store.filter.sortBy = this.tmpSort;
                this.sortDialogOpen = false;
                this.store.submitSearch();
            }
        },
        async batchDelete() {
            let result = await this.store.requestBatchDeleteStore(this.store.tableSelected);
            if (get(result, 'failedNum') > 0) {
                return this.waitAlert(`部分门店删除失败：${result.failedIds.join(',')}`, '错误');
            }
            this.showToast('删除成功', {type: 'success'});
            this.store.tableSelected = [];
            this.store.requestList();
        }
    }
});
</script>

<style lang="less">
.service-map-store-list-view {

}
.column-overlay {
    .veui-checkbox {
        display: inline-block;
        width: 50%;
        box-sizing: border-box;
        padding: 10px;
        margin: 0;
    }
}
</style>
